import { ArrayMapper, Mapper } from "../../../../../../harmony/core";
import { MediaEntityToMediaMapper } from "../../../../../features/media/domain/mappers/media.mapper";
import { RecommendedScheduleEntityToRecommendedScheduleMapper } from "../../../../../features/media/domain/mappers/recommended-schedules.mapper";
import { ImageMedia } from "../../../../../features/media/domain/models/media";
import {
  FacebookCarouselEntity,
  FacebookCarouselSlideEntity,
} from "../../data/entities/facebook-carousel.entity";
import { FacebookPostEntity } from "../../data/entities/facebook-post.entity";
import { FacebookStoryEntity } from "../../data/entities/facebook-story.entity";
import {
  FacebookCarousel,
  FacebookCarouselSlide,
  LinkType,
} from "../models/facebook-carousel";
import { FacebookPost } from "../models/facebook-post";
import { FacebookStory } from "../models/facebook-story";

export class CarouselSlideMapper
  implements Mapper<FacebookCarouselSlideEntity, FacebookCarouselSlide>
{
  private readonly mediaMapper = new MediaEntityToMediaMapper();
  public map(from: FacebookCarouselSlideEntity): FacebookCarouselSlide {
    return new FacebookCarouselSlide(
      this.mediaMapper.map(from.media) as ImageMedia,
      from.title,
      from.landingPageType ?? LinkType.CustomUrl,
      from.landingPageUrl,
      from.description,
    );
  }
}

export const mapFacebookCarouselEntityToModel = (
  from: FacebookCarouselEntity,
): FacebookCarousel => {
  const slideMapper = new CarouselSlideMapper();
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );

  return new FacebookCarousel(
    from.id,
    from.slides.map((slide) => slideMapper.map(slide)),
    from.text,
    from.landingPageUrl,
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};

export const mapFacebookPostEntityToModel = (
  from: FacebookPostEntity,
): FacebookPost => {
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );
  const mediaMapper = new MediaEntityToMediaMapper();

  return new FacebookPost(
    from.id,
    from.text,
    from.images.map((image) => mediaMapper.map(image)) as ImageMedia[],
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};

export const mapFacebookStoryEntityToModel = (
  from: FacebookStoryEntity,
): FacebookStory => {
  const mediaMapper = new MediaEntityToMediaMapper();
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );

  return new FacebookStory(
    from.id,
    mediaMapper.map(from.media),
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};
